import AiOldPhotoRestorationIcon from '../assets/svg/ai-old-photo-restoration.svg?react';
import AiFaceSwapIcon from '../assets/svg/ai-face-swap.svg?react';
import AiPhotoColorizerIcon from '../assets/svg/ai-photo-colorizer.svg?react';
import AiImageGeneratorIcon from '../assets/svg/ai-image-generator.svg?react';
import AiImageUpscalerIcon from '../assets/svg/ai-image-upscaler.svg?react';
import AiImageToImageIcon from '../assets/svg/ai-image-to-image.svg?react';
import AiImageExtenderIcon from '../assets/svg/ai-image-extender.svg?react';
import AiObjectEraserIcon from '../assets/svg/ai-object-eraser-icon.svg?react';
import AiImageBgRemoverIcon from '../assets/svg/bg-remove.svg?react';
import AiClothesChangerIcon from '../assets/svg/ai-clothes-changer.svg?react';
import AiVideoGeneratorIcon from '../assets/svg/ai-video-generator.svg?react';
import AiFake3dIcon from '../assets/svg/fake-3d.svg?react';
import AiAudioGeneratorIcon from '../assets/svg/ai-music.svg?react';
import AiVideoRemoveBgIcon from '../assets/svg/video-background-remover.svg?react';

import { RELEASE } from '../constants/FJEvnConstant';
const environment = import.meta.env.MODE;
const isRelease = environment !== RELEASE;
const FJHeaderConfig = {
    aiMenuList: [
        {
            hasMobile: true,
            title: 'ai-old-photo-restoration',
            icon: AiOldPhotoRestorationIcon,
            href: isRelease ? '/apply/old-photo-restoration/' : '/ai/old-photo-restoration/',
        },
        {
            hasMobile: true,
            title: 'ai-face-swap',
            icon: AiFaceSwapIcon,
            href: isRelease ? '/apply/face-swap/' : '/ai/face-swap/',
        },
        {
            hasMobile: true,
            title: 'ai-photo-colorizer',
            icon: AiPhotoColorizerIcon,
            href: isRelease ? '/apply/photo-colorizer/' : '/ai/photo-colorizer/',
        },
        {
            hasMobile: true,
            title: 'ai-text-to-image',
            icon: AiImageGeneratorIcon,
            href: isRelease ? '/apply/text-to-image/' : '/ai/text-to-image/',
        },
        {
            hasMobile: true,
            title: 'ai-image-upscaler',
            icon: AiImageUpscalerIcon,
            href: isRelease ? '/apply/image-upscaler/' : '/ai/image-upscaler/',
        },
        {
            hasMobile: true,
            title: 'ai-image-to-image',
            icon: AiImageToImageIcon,
            href: isRelease ? '/apply/image-to-image/' : '/ai/image-to-image/',
        },
        {
            hasMobile: true,
            title: 'ai-image-extender',
            icon: AiImageExtenderIcon,
            href: isRelease ? '/apply/image-extender/' : '/ai/image-extender/',
        },
        {
            hasMobile: false,
            title: 'ai-clothes-changer',
            icon: AiClothesChangerIcon,
            href: isRelease ? '/apply/clothes-changer/' : '/ai/clothes-changer/',
        },
        {
            title: '3d-photo-animation',
            icon: AiFake3dIcon,
            href: isRelease ? '/apply/3d-photo-animation/' : '/ai/3d-photo-animation/',
        },
        {
            hasMobile: true,
            title: 'ai-object-eraser',
            icon: AiObjectEraserIcon,
            href: isRelease ? '/apply/object-remover/' : '/ai/object-remover/',
        },
        {
            title: 'ai-image-bg-remover',
            icon: AiImageBgRemoverIcon,
            href: isRelease ? '/apply/image-background-remover/' : '/ai/image-background-remover/',
        },
        {
            title: 'ai-video-generator',
            icon: AiVideoGeneratorIcon,
            href: isRelease ? '/apply/video-generator/' : '/ai/video-generator/',
        },
        {
            title: 'ai-music-generator',
            icon: AiAudioGeneratorIcon,
            href: isRelease ? '/apply/music-generator/' : '/ai/music-generator/',
        },
        {
            title: 'ai-video-bg-remover',
            icon: AiVideoRemoveBgIcon,
            href: isRelease ? '/apply/video-background-remover/' : '/ai/video-background-remover/',
        },
    ],
};

export default FJHeaderConfig;
